// Libs
import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';
import { Action } from 'redux/types/Action';
// App
import { isRouterPathMatchingOneOfRoutes } from 'app-shared/lib/utils/router.utils';

/**
 * Interface definition for state
 */
interface State {
  /**
   * Stores the previous route
   */
  previousRoute: string;
}

/**
 * Type definition for state
 */
export type RouterHistoryState = Readonly<State>;

/**
 * Initial state definition
 */
const initialState: State = {
  previousRoute: null,
};

/**
 * Reducer definition
 */
const reducers = {
  setPreviousRoute: (state: State, action: Action<string>) => {
    state.previousRoute = action.payload;
  },
};

/**
 * Slice definition
 */
const routerHistorySlice = createSlice({
  name: 'routerHistory',
  initialState,
  reducers,
});

/**
 * Extract user navigation cache root state
 * @param   {Object} state The root state
 * @returns {State} The user preferences
 */
export const selectRouterHistory = (state: Readonly<RootState>): RouterHistoryState => state.routerHistory;

/**
 * Util for Checking if previous route is among provided list of routes
 * @param routes
 * @param previousRoute
 * @returns
 */
export const isPreviousRouteAmongRoutes = (routes: string[]) => (state: Readonly<RootState>): boolean => {
  return isRouterPathMatchingOneOfRoutes(state.routerHistory.previousRoute, routes);
};

/**
 * Actions definition
 */
export const { setPreviousRoute } = routerHistorySlice.actions;

export default routerHistorySlice.reducer;
